import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-form-debug',
  templateUrl: './form-debug.component.html',
  styleUrls: ['./form-debug.component.css'],
})
export class FormDebugComponent implements OnInit {
  production = true;
  @Input() form;

  constructor() {}

  ngOnInit() {
    this.production = environment.production;
  }
}
